import { Component, HostListener, Renderer2, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, NavigationEnd, NavigationStart, ActivatedRoute } from '@angular/router';
import { AppVariablesService } from './service/app-variables.service';
import { AppSettings } from './service/app-settings.service';
import { LoginService } from './service/login/login.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit {
	tokenVerifier: any 
	
  constructor(private loginService: LoginService, private router: Router, private renderer: Renderer2, public appSettings: AppSettings, private appVariablesService: AppVariablesService) {
    router.events.subscribe((e) => {
			if (e instanceof NavigationStart) {
			  if (window.innerWidth < 768) {
			    this.appSettings.appSidebarMobileToggled = false;
			    this.appSettings.appSidebarEndMobileToggled = false;
			  }
			}
    });

	this.tokenVerifier = setInterval(() => {
		
		if(loginService.haySesionActiva()){
			let aux = new Date((localStorage.getItem("date_token")))
			let actual = new Date()
		
			const diferenciaMilisegundos = Math.abs(actual.getTime() - aux.getTime());
			const segundosLogeado = diferenciaMilisegundos / (1000);

			console.log(' DIF MILI',diferenciaMilisegundos)
			console.log(' SEGUNDOS LOGUEADO', segundosLogeado)

			let expiracionToken = parseInt(localStorage.getItem("minutesToExpire")) * 60

			console.log('EXPIRACION TOKEN', expiracionToken)
			this.reautenticar((expiracionToken - segundosLogeado) <= 60);

			/*if((expiracionToken - diferenciaMinutos) <= 60){
				this.reautenticar()
			}else{
				// this.reautenticar()
			}*/
		}else{
		}
	  }, 45000);
  }

	// window scroll
  appHasScroll;
  
	appVariables = this.appVariablesService.getAppVariables();

  ngOnInit() {
    // page settings
    	if (this.appSettings.appDarkMode) {
			this.onAppDarkModeChanged(true);
		}
		
		if(this.loginService.haySesionActiva()){
            if(this.loginService.validarTokenValido() === false){
 
                this.loginService.LogOutSession()
                this.router.navigate(['/LogIn']);
            }
        }else{
            this.loginService.LogOutSession()
            this.router.navigate(['/LogIn']);
        }
 
        if (this.appSettings.appDarkMode) {
            this.onAppDarkModeChanged(true);
        }

		if (localStorage) {
			if (localStorage['appDarkMode']) {
				this.appSettings.appDarkMode = (localStorage['appDarkMode'] === 'true') ? true : false;
				if (this.appSettings.appDarkMode) {
					this.onAppDarkModeChanged(true);
				}
			}
			if (localStorage['appHeaderFixed']) {
				this.appSettings.appHeaderFixed = (localStorage['appHeaderFixed'] === 'true') ? true : false;
			}
			if (localStorage['appHeaderInverse']) {
				this.appSettings.appHeaderInverse = (localStorage['appHeaderInverse'] === 'true') ? true : false;
			}
			if (localStorage['appSidebarFixed']) {
				this.appSettings.appSidebarFixed = (localStorage['appSidebarFixed'] === 'true') ? true : false;
			}
			if (localStorage['appSidebarMinified']) {
				this.appSettings.appSidebarMinified = (localStorage['appSidebarMinified'] === 'true') ? true : false;
			}
			if (localStorage['appSidebarGrid']) {
				this.appSettings.appSidebarGrid = (localStorage['appSidebarGrid'] === 'true') ? true : false;
			}
			if (localStorage['appGradientEnabled']) {
				this.appSettings.appGradientEnabled = (localStorage['appGradientEnabled'] === 'true') ? true : false;
			}
		}
  }
  @HostListener('window:scroll', ['$event'])
  onWindowScroll($event) {
    const doc = document.documentElement;
    const top = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0);
    if (top > 0 && this.appSettings.appHeaderFixed) {
      this.appHasScroll = true;
    } else {
      this.appHasScroll = false;
    }
  }

  // set page minified
  onAppSidebarMinifiedToggled(val: boolean): void {
  	this.appSettings.appSidebarMinified = !this.appSettings.appSidebarMinified;
  	if (localStorage) {
			localStorage['appSidebarMinified'] = this.appSettings.appSidebarMinified;
		}
	}

  // set app sidebar end toggled
  onAppSidebarEndToggled(val: boolean): void {
  	this.appSettings.appSidebarEndToggled = !this.appSettings.appSidebarEndToggled;
	}

  // hide mobile sidebar
  onAppSidebarMobileToggled(val: boolean): void {
  	this.appSettings.appSidebarMobileToggled = !this.appSettings.appSidebarMobileToggled;
	}

  // toggle right mobile sidebar
  onAppSidebarEndMobileToggled(val: boolean): void {
  	this.appSettings.appSidebarEndMobileToggled = !this.appSettings.appSidebarEndMobileToggled;
	}

	onAppDarkModeChanged(val: boolean): void {
		if (this.appSettings.appDarkMode) {
			document.documentElement.setAttribute('data-bs-theme', 'dark');
		} else {
			document.documentElement.removeAttribute('data-bs-theme');
		}
		this.appVariables = this.appVariablesService.getAppVariables();
		this.appVariablesService.variablesReload.emit();
		document.dispatchEvent(new CustomEvent('theme-change'));
	}
	

	onAppThemeChanged(val: boolean): void {
		const newTheme = 'theme-' + this.appSettings.appTheme;
		for (let x = 0; x < document.body.classList.length; x++) {
			if ((document.body.classList[x]).indexOf('theme-') > -1 && document.body.classList[x] !== newTheme) {
				document.body.classList.remove(document.body.classList[x]);
			}
		}
		document.body.classList.add(newTheme);
		this.appVariables = this.appVariablesService.getAppVariables();
		this.appVariablesService.variablesReload.emit();
	}

	dispose() {
		clearInterval(this.tokenVerifier)
	}

	/*reautenticar(){
		let body = {
			userName: this.loginService.getVariableSesion('userName'),
			token: this.loginService.getVariableSesion('token')
		}
		this.loginService.reautenticarToken(body).subscribe(
			data => {
				this.loginService.setVariableSession('token', data.token)
				this.loginService.setVariableSession('minutesToExpire', data.minutesToExpire)
				this.loginService.setVariableSession("date_token", new Date().toString())
			}
		)
	}*/

	reautenticar(renew: boolean) {
        let body = {
            id: this.loginService.getVariableSesion('id'),
            userName: this.loginService.getVariableSesion('userName'),
            token: this.loginService.getVariableSesion('token')
        }
        this.loginService.reautenticarToken(renew, body).subscribe(
            data => {
                if (renew) {
                    this.loginService.setVariableSession('token', data.token)
                    this.loginService.setVariableSession('minutesToExpire', data.minutesToExpire)
                    this.loginService.setVariableSession("date_token", new Date().toString())
                }
            }
        )
    }
}
